// extracted by mini-css-extract-plugin
export default {"placeholderIcon":"CepFilterDropdown_placeholderIcon__LTeBI","optionLabel":"CepFilterDropdown_optionLabel__NDDlV","iconCheck":"CepFilterDropdown_iconCheck__FDKLC"};